/**
 * Keyswitch
 * - used in Charleroi
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Konva from 'konva'

export default class Ksw extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'keyswitch',
        x: 0,
        y: 0,
        width: 100,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'keyswitchText',
        x: 1,
        y: 10,
        width: 90,
        fontSize: 14,
        align: 'center',
        fill: 'black'
      })
    )
  }

  // annulation will be red text
  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)
    if (deviceTypes && (status.display || status.display === 0)) {
      const deviceConfig = (Array.isArray(deviceTypes)) ? deviceTypes.find(config => config.name === 'Ksw') : deviceTypes['Ksw']
      const variablesConfig = deviceConfig.variables.display.config
      const kswText = variablesConfig[status.display].code
      if (status) {
        this.modifyShape('keyswitchText', 'text', kswText)
      }
    }
  }
}
